import Arrow from "../../assets/img/Ico/Arrow.svg";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { gsap } from "gsap";

export default function Service() {
  const { t } = useTranslation();
  const [activeService, setActiveService] = useState("webDev");
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);
  const menuItemsRef = useRef([]);
  const contentRef = useRef(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    const checkDeviceType = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
    };

    checkDeviceType();
    window.addEventListener("resize", checkDeviceType);

    return () => window.removeEventListener("resize", checkDeviceType);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectOpen && !event.target.closest(".Service-CustomSelect")) {
        setSelectOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [selectOpen]);

  // Animation des boutons menu sur desktop
  useEffect(() => {
    if (!isMobile && !isTablet && menuItemsRef.current.length > 0) {
      gsap.fromTo(
        menuItemsRef.current,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          delay: 0.3,
        }
      );
    }
  }, [isMobile, isTablet]);

  // Animation du contenu qui monte lors du changement
  const animateContentChange = (newService) => {
    if (contentRef.current && !isInitialLoad) {
      gsap.fromTo(
        contentRef.current,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.4, ease: "power2.out" }
      );
    }
    setActiveService(newService);
    setIsInitialLoad(false);
  };

  const service = {
    webDev: {
      title: t("service.webDev.title"),
      content: (
        <>
          <p className="Service-Highlight-Purple">
            {t("service.webDev.intro1")}
          </p>
          <p className="Service-Highlight-Purple">
            {t("service.webDev.intro2")}
          </p>

          <p
            dangerouslySetInnerHTML={{ __html: t("service.webDev.paragraph1") }}
          />

          <article className={`Service-More  ${open ? "open" : ""}`}>
            <p>{t("service.webDev.paragraph2")}</p>

            <p className="Service-Bold-White">
              {t("service.webDev.conclusion")}
            </p>

            <div className="Service-Features">
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.webDev.feature1Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.webDev.feature1Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.webDev.feature2Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.webDev.feature2Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.webDev.feature3Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.webDev.feature3Text")}
                </p>
              </div>
            </div>

            <h3 className="Service-Subtitle">{t("service.webDev.subtitle")}</h3>
            <p className="Service-Highlight-Purple">
              {t("service.webDev.visibilityText")}
            </p>
            <ul className="Service-List">
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.webDev.benefit1")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.webDev.benefit2")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.webDev.benefit3")}
              </li>
            </ul>
          </article>
        </>
      ),
    },
    infogerance: {
      title: t("service.infogerance.title"),
      content: (
        <>
          <p>{t("service.infogerance.intro")}</p>
          <p className="Service-Highlight-Purple">
            {t("service.infogerance.highlight")}
          </p>
          <p>{t("service.infogerance.paragraph1")}</p>
          <p>{t("service.infogerance.paragraph2")}</p>

          <article className={`Service-More  ${open ? "open" : ""}`}>
            <div className="Service-Features">
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.infogerance.feature1Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.infogerance.feature1Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.infogerance.feature2Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.infogerance.feature2Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.infogerance.feature3Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.infogerance.feature3Text")}
                </p>
              </div>
            </div>

            <div className="Service-Two-Columns">
              <div className="Service-Column-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.infogerance.column1Title")}
                </h4>
                <p>{t("service.infogerance.column1Text")}</p>
              </div>
              <div className="Service-Column-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.infogerance.column2Title")}
                </h4>
                <p>{t("service.infogerance.column2Text")}</p>
              </div>
            </div>

            <h3 className="Service-Subtitle">
              {t("service.infogerance.subtitle")}
            </h3>
            <p className="Service-Highlight-Purple">
              {t("service.infogerance.subtitleHighlight")}
            </p>
            <ul className="Service-List">
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.infogerance.benefit1")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.infogerance.benefit2")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.infogerance.benefit3")}
              </li>
            </ul>
          </article>
        </>
      ),
    },
    referencement: {
      title: t("service.referencement.title"),
      content: (
        <>
          <p>
            {t("service.referencement.intro1")}{" "}
            <span style={{ textDecoration: "underline" }}>C'est bien !</span>
          </p>
          <p>
            {t("service.referencement.intro2")}{" "}
            <span style={{ textDecoration: "underline" }}>C'est mieux !</span>
          </p>
          <p>{t("service.referencement.paragraph1")}</p>
          <p className="Service-Highlight-Purple">
            {t("service.referencement.highlight1")}
          </p>
          <p>{t("service.referencement.paragraph2")}</p>
          <article className={`Service-More  ${open ? "open" : ""}`}>
            <h4>{t("service.referencement.seoTitle")}</h4>
            <p>{t("service.referencement.seoParagraph1")}</p>
            <p>{t("service.referencement.seoParagraph2")}</p>
            <p>{t("service.referencement.seoParagraph3")}</p>

            <h4>{t("service.referencement.seaTitle")}</h4>
            <p>{t("service.referencement.seaParagraph1")}</p>
            <p>{t("service.referencement.seaParagraph2")}</p>
            <p>{t("service.referencement.seaParagraph3")}</p>
            <p>{t("service.referencement.seaParagraph4")}</p>
            <p>{t("service.referencement.seaParagraph5")}</p>

            <div className="Service-Features">
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.referencement.feature1Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.referencement.feature1Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.referencement.feature2Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.referencement.feature2Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.referencement.feature3Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.referencement.feature3Text")}
                </p>
              </div>
            </div>

            <h3 className="Service-Subtitle">
              {t("service.referencement.subtitle")}
            </h3>
            <p className="Service-Highlight-Purple">
              {t("service.referencement.subtitleHighlight")}
            </p>
            <ul className="Service-List">
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.referencement.benefit1")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.referencement.benefit2")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.referencement.benefit3")}
              </li>
            </ul>
          </article>
        </>
      ),
    },
    sauvegarde: {
      title: t("service.sauvegarde.title"),
      content: (
        <>
          <p
            dangerouslySetInnerHTML={{
              __html: t("service.sauvegarde.paragraph1"),
            }}
          />
          <p>{t("service.sauvegarde.paragraph2")}</p>
          <p
            dangerouslySetInnerHTML={{
              __html: t("service.sauvegarde.paragraph3"),
            }}
          />
          <p>{t("service.sauvegarde.paragraph4")}</p>
          <p>{t("service.sauvegarde.paragraph5")}</p>
          <article className={`Service-More  ${open ? "open" : ""}`}>
            <strong className="Service-Highlight-Purple">
              {t("service.sauvegarde.highlight1")}
            </strong>
            <p></p>
            <p
              dangerouslySetInnerHTML={{
                __html: t("service.sauvegarde.paragraph6"),
              }}
            />
            <p>{t("service.sauvegarde.paragraph7")}</p>
            <p
              dangerouslySetInnerHTML={{
                __html: t("service.sauvegarde.paragraph8"),
              }}
            />

            <div className="Service-Features">
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.sauvegarde.feature1Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.sauvegarde.feature1Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.sauvegarde.feature2Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.sauvegarde.feature2Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.sauvegarde.feature3Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.sauvegarde.feature3Text")}
                </p>
              </div>
            </div>

            <h3 className="Service-Subtitle">
              {t("service.sauvegarde.subtitle")}
            </h3>
            <p className="Service-Highlight-Purple">
              {t("service.sauvegarde.subtitleHighlight")}
            </p>
            <ul className="Service-List">
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.sauvegarde.benefit1")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.sauvegarde.benefit2")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.sauvegarde.benefit3")}
              </li>
            </ul>
          </article>
        </>
      ),
    },
    cloud: {
      title: t("service.cloud.title"),
      content: (
        <>
          <p>{t("service.cloud.paragraph1")}</p>
          <p
            dangerouslySetInnerHTML={{ __html: t("service.cloud.paragraph2") }}
          />
          <p>{t("service.cloud.paragraph3")}</p>
          <p className="Service-Highlight-Purple">
            {t("service.cloud.highlight1")}
          </p>
          <p
            dangerouslySetInnerHTML={{ __html: t("service.cloud.paragraph4") }}
          />
          <p
            dangerouslySetInnerHTML={{ __html: t("service.cloud.paragraph5") }}
          />
          <p>{t("service.cloud.paragraph6")}</p>
          <article className={`Service-More  ${open ? "open" : ""}`}>
            <div className="Service-Features">
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.cloud.feature1Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.cloud.feature1Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.cloud.feature2Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.cloud.feature2Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.cloud.feature3Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.cloud.feature3Text")}
                </p>
              </div>
            </div>

            <div className="Service-Two-Columns">
              <div className="Service-Column-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.cloud.column1Title")}
                </h4>
                <p>{t("service.cloud.column1Text")}</p>
              </div>
              <div className="Service-Column-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.cloud.column2Title")}
                </h4>
                <p>{t("service.cloud.column2Text")}</p>
              </div>
            </div>

            <h3 className="Service-Subtitle">{t("service.cloud.subtitle")}</h3>
            <p className="Service-Highlight-Purple">
              {t("service.cloud.subtitleHighlight")}
            </p>
            <ul className="Service-List">
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.cloud.benefit1")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.cloud.benefit2")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.cloud.benefit3")}
              </li>
            </ul>
          </article>
        </>
      ),
    },
    telecom: {
      title: t("service.telecom.title"),
      content: (
        <>
          <p>{t("service.telecom.paragraph1")}</p>
          <p className="Service-Highlight-Purple">
            {t("service.telecom.highlight1")}
          </p>
          <p>{t("service.telecom.paragraph2")}</p>
          {/* <article className={`Service-More  ${open ? "open" : ""}`}> */}
          {/* <div className="Service-Features">
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.telecom.feature1Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.telecom.feature1Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.telecom.feature2Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.telecom.feature2Text")}
                </p>
              </div>
              <div className="Service-Feature-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.telecom.feature3Title")}
                </h4>
                <p className="Service-Feature-Text">
                  {t("service.telecom.feature3Text")}
                </p>
              </div>
            </div> */}

          {/* <div className="Service-Two-Columns">
              <div className="Service-Column-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.telecom.column1Title")}
                </h4>
                <p>{t("service.telecom.column1Text")}</p>
              </div>
              <div className="Service-Column-Item">
                <h4 className="Service-Feature-Title">
                  {t("service.telecom.column2Title")}
                </h4>
                <p>{t("service.telecom.column2Text")}</p>
              </div>
            </div> */}

          {/* <h3 className="Service-Subtitle">
              {t("service.telecom.subtitle")}
            </h3>
            <p className="Service-Highlight-Purple">
              {t("service.telecom.subtitleHighlight")}
            </p>
            <ul className="Service-List">
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.telecom.benefit1")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.telecom.benefit2")}
              </li>
              <li className="Service-List-Item">
                <span className="checkmark"></span>
                {t("service.telecom.benefit3")}
              </li>
            </ul> */}
          {/* </article> */}
        </>
      ),
    },
    socialMedia: {
      title: t("service.socialMedia.title"),
      content: (
        <>
          <p className="Service-Highlight-Purple">
            {t("service.socialMedia.subtitle")}
          </p>

          <p>{t("service.socialMedia.paragraph1")}</p>

          <p>{t("service.socialMedia.paragraph2")}</p>

          <p className="Service-Highlight-Purple">
            {t("service.socialMedia.paragraph3")}
          </p>

          <p>{t("service.socialMedia.conclusion")}</p>
        </>
      ),
    },
    webDesign: {
      title: t("service.webDesign.title"),
      content: (
        <>
          <p className="Service-Highlight-Purple">
            {t("service.webDesign.subtitle")}
          </p>

          <p>{t("service.webDesign.paragraph1")}</p>

          <p>{t("service.webDesign.paragraph2")}</p>

          <p>{t("service.webDesign.paragraph3")}</p>

          <p className="Service-Highlight-Purple">
            {t("service.webDesign.conclusion")}
          </p>
        </>
      ),
    },
    graphique: {
      title: t("service.graphique.title"),
      content: (
        <>
          <p className="Service-Highlight-Purple">
            {t("service.graphique.subtitle")}
          </p>

          <p>{t("service.graphique.paragraph1")}</p>

          <p>{t("service.graphique.paragraph2")}</p>

          <p className="Service-Highlight-Purple">
            {t("service.graphique.conclusion")}
          </p>
        </>
      ),
    },
    contenu: {
      title: t("service.contenu.title"),
      content: (
        <>
          <p className="Service-Highlight-Purple">
            {t("service.contenu.subtitle")}
          </p>

          <p>{t("service.contenu.paragraph1")}</p>

          <p>{t("service.contenu.paragraph2")}</p>

          <p className="Service-Highlight-Purple">
            {t("service.contenu.conclusion")}
          </p>
        </>
      ),
    },
  };

  const menuItems = [
    { key: "webDev", label: t("service.menu.webDev") },
    { key: "infogerance", label: t("service.menu.infogerance") },
    { key: "referencement", label: t("service.menu.referencement") },
    { key: "sauvegarde", label: t("service.menu.sauvegarde") },
    { key: "cloud", label: t("service.menu.cloud") },
    { key: "telecom", label: t("service.menu.telecom") },
    { key: "socialMedia", label: t("service.menu.socialMedia") },
    { key: "webDesign", label: t("service.menu.webDesign") },
    { key: "graphique", label: t("service.menu.graphique") },
    { key: "contenu", label: t("service.menu.contenu") },
  ];

  return (
    <div className="Service">
      <div className="Service-Top">
        <div className="Service-Top-Title">
          <h2>{t("servicePage.title")}</h2>
        </div>
        <div className="Service-Top-Side">
          <span className="checkmark">{t("servicePage.point1")}</span>
          <span className="checkmark">{t("servicePage.point2")}</span>
          <span className="checkmark">{t("servicePage.point3")}</span>
          <span className="checkmark">{t("servicePage.point4")}</span>
          <span className="checkmark">{t("servicePage.point5")}</span>
        </div>
      </div>
      <div className="Service-Info">
        <div className="Service-Menu">
          {isMobile || isTablet ? (
            <div className="Service-CustomSelect">
              <div
                className={`Service-CustomSelect-Trigger ${
                  selectOpen ? "open" : ""
                }`}
                onClick={() => setSelectOpen(!selectOpen)}
              >
                <span className="Service-CustomSelect-Value">
                  {menuItems.find((item) => item.key === activeService)?.label}
                </span>
                <span
                  className={`Service-CustomSelect-Arrow ${
                    selectOpen ? "rotated" : ""
                  }`}
                ></span>
              </div>
              {selectOpen && (
                <div className="Service-CustomSelect-Options">
                  {menuItems.map((item) => (
                    <div
                      key={item.key}
                      className={`Service-CustomSelect-Option ${
                        activeService === item.key ? "active" : ""
                      }`}
                      onClick={() => {
                        animateContentChange(item.key);
                        setSelectOpen(false);
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            menuItems.map((item, index) => (
              <div
                key={item.key}
                ref={(el) => (menuItemsRef.current[index] = el)}
                className={`Service-Menu-Item ${
                  activeService === item.key ? "active" : ""
                }`}
                onClick={() => animateContentChange(item.key)}
              >
                {activeService === item.key && (
                  <span className="icon">
                    <img
                      src={Arrow}
                      className="chevron arrow"
                      alt={t("footer.altToggle")}
                    />
                  </span>
                )}
                <span className="label">{item.label}</span>
              </div>
            ))
          )}
        </div>
        <div className="Service-Content" ref={contentRef}>
          <h3>{service[activeService].title}</h3>
          {service[activeService].content}
          {[
            "webDev",
            "infogerance",
            "referencement",
            "sauvegarde",
            "cloud",
          ].includes(activeService) && (
            <button
              className={`learn-more ${open ? "open" : ""}`}
              type="button"
              aria-expanded={open}
              aria-controls="footer-client-links"
              onClick={() => setOpen((v) => !v)}
            >
              {t("servicePage.learnMore")}{" "}
              <span>
                <img
                  src={Arrow}
                  className={`chevron arrow ${open ? "rotated" : ""}`}
                  alt={t("footer.altToggle")}
                />
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
